"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enhanceLogisticOffersForConfig = exports.enhanceLogisticOfferForConfig = void 0;
const delivery_mode_business_name_1 = require("../delivery-mode-business-name");
const enhanceLogisticOfferForConfig = (logisticOffer) => ({
    ...logisticOffer,
    deliveryModeBusinessName: (0, delivery_mode_business_name_1.deliveryModeBusinessName)(logisticOffer.deliveryModeName, logisticOffer.delayUnit && logisticOffer.delayValue
        ? {
            unit: logisticOffer.delayUnit,
            value: logisticOffer.delayValue
        }
        : undefined)
});
exports.enhanceLogisticOfferForConfig = enhanceLogisticOfferForConfig;
const enhanceLogisticOffersForConfig = (logisticOffers) => logisticOffers.map(logisticOffer => (0, exports.enhanceLogisticOfferForConfig)(logisticOffer));
exports.enhanceLogisticOffersForConfig = enhanceLogisticOffersForConfig;
